import { render } from "./DownloadComments.vue?vue&type=template&id=298d0aae"
import script from "./DownloadComments.vue?vue&type=script&lang=js"
export * from "./DownloadComments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__